import {Stack, CheckboxGroup, HStack, Checkbox, Text, Icon} from "@chakra-ui/react";
import {DocumentExternal, DocumentId} from "platformed-client/types";
import {DOCUMENT_CATEGORY_MAP} from "../../../Products/VendorToolkit/components/DocumentCategory";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";
import React from "react";
import {Tag} from "../../../components/ui/tag";
import T from "platformed-components/i18n/T";

type DocumentSelectorProps = {
  documents: DocumentExternal[];
  value: DocumentId[];
  onChange: (value: DocumentId[]) => void;
};

function RestrictedDocumentSelector({documents, value, onChange}: DocumentSelectorProps) {
  return (
    <Stack border="1px solid" borderColor="gray.200" rounded="md" flex="1" gap={0} overflow="hidden" bg="gray.50">
      <CheckboxGroup value={value} onValueChange={v => onChange(v as DocumentId[])}>
        <Stack p={0} gap={0} flex="1">
          {Object.entries(DOCUMENT_CATEGORY_MAP).map(([c, i]) => {
            const filteredDocuments = documents.filter(d => d.category === c);

            return filteredDocuments.length > 0 ? (
              <React.Fragment key={c}>
                <HStack p={2} px={4} borderBottom="1px solid" borderColor="gray.200" bg="blue.500" color="white">
                  <Text fontSize="md" fontWeight="500">
                    {i.textPlural}
                  </Text>
                </HStack>
                {filteredDocuments.map(d => (
                  <Checkbox.Root
                    key={d.document_id}
                    value={d.document_id}
                    borderBottom="1px solid"
                    borderColor="gray.200"
                    px={4}
                    py={3}
                    gap={4}
                    // Style the inner label
                    css={{"& > :last-child": {flex: "1"}}}
                    _hover={{bg: "gray.50"}}
                    _active={{bg: "gray.100"}}
                    alignSelf="stretch"
                    bg="white"
                  >
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>
                      <HStack justifyContent="space-between">
                        <Text>{d.name}</Text>
                        {d.requires_esignature && (
                          <Tag colorPalette="blue">
                            <T keyName="c.Requires_NDA" />
                          </Tag>
                        )}
                      </HStack>
                    </Checkbox.Label>
                  </Checkbox.Root>
                ))}
              </React.Fragment>
            ) : null;
          })}
        </Stack>
      </CheckboxGroup>
      {value.length === 0 && (
        <HStack p={2} px={4} gap={4} bg="red.100" color="red.800" fontSize="md">
          <Icon as={ExclamationCircleIcon} boxSize="1em" />
          <Text>
            <T keyName="trust_center.request_access.select_at_least_one_document" />
          </Text>
        </HStack>
      )}
    </Stack>
  );
}

export default RestrictedDocumentSelector;
